import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';

const MainServicesSection = () => {
  const { language } = useLanguage();

  const serviceStats = [
    { value: '98%', label: language === 'fr' ? 'Satisfaction client' : language === 'ar' ? 'رضا العملاء' : 'Client satisfaction' },
    { value: '20+', label: language === 'fr' ? 'Services, installations' : language === 'ar' ? 'الخدمات والتركيبات' : 'Services, installations' },
    { value: '15+', label: language === 'fr' ? 'Années d\'expertise' : language === 'ar' ? 'سنوات من الخبرة' : 'Years of expertise' }
  ];

  const mainServices = [
    {
      title: language === 'fr' ? 'Fourniture et installation' : 
             language === 'ar' ? 'التوريد والتركيب' : 
             'Supply and Installation',
      description: language === 'fr' ? 'Fourniture et installation complète de systèmes d\'instrumentation Panametrics pour le secteur Pétrole, Gaz et Industrie, avec configuration sur site et tests de validation.' :
                   language === 'ar' ? 'توريد وتركيب شامل لأنظمة قياس Panametrics لقطاع النفط والغاز والصناعة، مع التكوين في الموقع واختبارات التحقق.' :
                   'Complete supply and installation of Panametrics instrumentation systems for Oil, Gas and Industry sector, with on-site configuration and validation testing.',
      image: "https://images.unsplash.com/photo-1621905251189-08b45249f78a?q=80&w=2069&auto=format&fit=crop",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '48px', height: '48px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
        </svg>
      ),
      features: [
        language === 'fr' ? 'Installation complète sur site' : 
        language === 'ar' ? 'تركيب شامل في الموقع' : 
        'Complete on-site installation',
        language === 'fr' ? 'Configuration et calibration des équipements' : 
        language === 'ar' ? 'تكوين ومعايرة المعدات' : 
        'Equipment configuration and calibration',
        language === 'fr' ? 'Tests de validation et mise en service' : 
        language === 'ar' ? 'اختبارات التحقق والتشغيل' : 
        'Validation testing and commissioning'
      ],
      benefits: [
        language === 'fr' ? 'Installation professionnelle certifiée' : 
        language === 'ar' ? 'تركيب احترافي معتمد' : 
        'Certified professional installation',
        language === 'fr' ? 'Garantie sur l\'installation et les équipements' : 
        language === 'ar' ? 'ضمان على التركيب والمعدات' : 
        'Warranty on installation and equipment',
        language === 'fr' ? 'Support technique complet' : 
        language === 'ar' ? 'دعم فني شامل' : 
        'Complete technical support'
      ]
    },
    {
      title: language === 'fr' ? 'Formation technique' : 
             language === 'ar' ? 'التدريب التقني' : 
             'Technical Training',
      description: language === 'fr' ? 'Programmes de formation technique spécialisés pour votre personnel sur l\'utilisation, la maintenance et l\'optimisation des systèmes d\'instrumentation Panametrics.' :
                   language === 'ar' ? 'برامج تدريب تقني متخصصة لموظفيك على استخدام وصيانة وتحسين أنظمة قياس Panametrics.' :
                   'Specialized technical training programs for your staff on the use, maintenance and optimization of Panametrics instrumentation systems.',
      image: "https://images.unsplash.com/photo-1531482615713-2afd69097998?q=80&w=2070&auto=format&fit=crop",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '48px', height: '48px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
      ),
      features: [
        language === 'fr' ? 'Formation sur site personnalisée' : 
        language === 'ar' ? 'تدريب في الموقع مخصص' : 
        'Customized on-site training',
        language === 'fr' ? 'Documentation technique complète' : 
        language === 'ar' ? 'وثائق تقنية شاملة' : 
        'Complete technical documentation',
        language === 'fr' ? 'Certification du personnel' : 
        language === 'ar' ? 'شهادة للموظفين' : 
        'Staff certification'
      ],
      benefits: [
        language === 'fr' ? 'Amélioration des compétences techniques' : 
        language === 'ar' ? 'تحسين المهارات التقنية' : 
        'Enhanced technical skills',
        language === 'fr' ? 'Réduction des erreurs opérationnelles' : 
        language === 'ar' ? 'تقليل الأخطاء التشغيلية' : 
        'Reduced operational errors',
        language === 'fr' ? 'Autonomie dans la maintenance de base' : 
        language === 'ar' ? 'استقلالية في الصيانة الأساسية' : 
        'Independence in basic maintenance'
      ]
    },
    {
      title: language === 'fr' ? 'Maintenance préventive' : 
             language === 'ar' ? 'الصيانة الوقائية' : 
             'Preventive Maintenance',
      description: language === 'fr' ? 'Services de maintenance préventive et curative pour débitmétrie et analyseurs en ligne, assurant la fiabilité et la précision de vos équipements de mesure.' :
                   language === 'ar' ? 'خدمات الصيانة الوقائية والعلاجية لأجهزة قياس التدفق والمحللات عبر الإنترنت، مما يضمن موثوقية ودقة معدات القياس الخاصة بك.' :
                   'Preventive and curative maintenance services for flow meters and online analyzers, ensuring the reliability and accuracy of your measurement equipment.',
      image: "https://images.unsplash.com/photo-1581094277593-8c0210ddaf32?q=80&w=2070&auto=format&fit=crop",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '48px', height: '48px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      ),
      features: [
        language === 'fr' ? 'Inspection complète des équipements' : 
        language === 'ar' ? 'فحص شامل للمعدات' : 
        'Complete equipment inspection',
        language === 'fr' ? 'Calibration selon les normes fabricant' : 
        language === 'ar' ? 'معايرة وفقاً لمعايير الشركة المصنعة' : 
        'Calibration according to manufacturer standards',
        language === 'fr' ? 'Rapports détaillés de maintenance' : 
        language === 'ar' ? 'تقارير صيانة مفصلة' : 
        'Detailed maintenance reports'
      ],
      benefits: [
        language === 'fr' ? 'Réduction des temps d\'arrêt' : 
        language === 'ar' ? 'تقليل أوقات التوقف' : 
        'Reduced downtime',
        language === 'fr' ? 'Optimisation des performances' : 
        language === 'ar' ? 'تحسين الأداء' : 
        'Performance optimization',
        language === 'fr' ? 'Prolongation de la durée de vie' : 
        language === 'ar' ? 'إطالة عمر المعدات' : 
        'Extended equipment life'
      ]
    }
  ];

  return (
    <section className="section section-dark py-24" style={{ position: 'relative', overflow: 'hidden' }}>
      {/* Decorative background elements */}
      <div style={{
        position: 'absolute',
        top: '5%',
        right: '-5%',
        width: '400px',
        height: '400px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 107, 0, 0.08) 0%, rgba(255, 107, 0, 0) 70%)',
        zIndex: 1
      }}></div>
      
      <div style={{
        position: 'absolute',
        bottom: '5%',
        left: '-5%',
        width: '400px',
        height: '400px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 107, 0, 0.08) 0%, rgba(255, 107, 0, 0) 70%)',
        zIndex: 1
      }}></div>
      
      <div className="container mx-auto px-4 lg:px-8" style={{ position: 'relative', zIndex: 2 }}>
        {/* Section Header */}
        <div className="mb-20">
          <h2 className="main-services-title text-center fade-in" style={{ 
            fontSize: '2.75rem', 
            fontWeight: '700',
            marginBottom: '1.5rem',
            position: 'relative',
            paddingBottom: '1.5rem',
            textAlign: 'center'
          }}>
{language === 'fr' ? 'Services principaux' : 
             language === 'ar' ? 'الخدمات الرئيسية' : 
             'Main Services'}
            <span style={{
              position: 'absolute',
              bottom: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              width: '80px',
              height: '4px',
              backgroundColor: 'var(--assco-orange)',
              borderRadius: '2px'
            }}></span>
          </h2>
          
          <p className="subtitle text-center fade-in" style={{ 
            maxWidth: '800px',
            margin: '0 auto 2rem',
            fontSize: '1.25rem',
            lineHeight: '1.8',
            color: 'var(--assco-gray-600)'
          }}>
            {language === 'fr' 
              ? 'Nos services principaux sont conçus pour répondre aux besoins spécifiques de l\'industrie et du secteur Pétrole & Gaz'
              : language === 'ar'
              ? 'تم تصميم خدماتنا الرئيسية لتلبية الاحتياجات المحددة للصناعة وقطاع النفط والغاز'
              : 'Our main services are designed to meet the specific needs of the industry and the Oil & Gas sector'}
          </p>
          
          {/* Statistics Bar */}
          <div className="stats-bar fade-in" style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '4rem',
            marginTop: '3rem',
            padding: '2rem',
            borderRadius: '12px',
            backgroundColor: 'rgba(255, 107, 0, 0.05)',
            boxShadow: '0 10px 30px -15px rgba(0, 0, 0, 0.1)'
          }}>
            {serviceStats.map((stat, idx) => (
              <div key={idx} style={{ textAlign: 'center' }}>
                <div style={{
                  fontSize: '2.5rem',
                  fontWeight: '700',
                  color: 'var(--assco-orange)',
                  marginBottom: '0.5rem'
                }}>{stat.value}</div>
                <div style={{
                  fontSize: '1.125rem',
                  color: 'var(--assco-gray-700)'
                }}>{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
        
        {/* Enhanced Service Cards Grid */}
        <div className="services-grid fade-in" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(380px, 1fr))',
          gap: '2.5rem',
          marginTop: '4rem'
        }}>
          {mainServices.map((service, index) => (
            <div 
              key={index}
              className="service-card-enhanced fade-in"
              style={{
                backgroundColor: 'white',
                borderRadius: '24px',
                overflow: 'hidden',
                boxShadow: '0 20px 40px -15px rgba(0, 0, 0, 0.1)',
                border: '1px solid rgba(0, 0, 0, 0.05)',
                transition: 'all 0.4s ease',
                animationDelay: `${0.2 * index}s`,
                position: 'relative'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-15px)';
                e.currentTarget.style.boxShadow = '0 30px 60px -15px rgba(0, 0, 0, 0.15)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 20px 40px -15px rgba(0, 0, 0, 0.1)';
              }}
            >
              {/* Service Header with Icon and Image */}
              <div style={{
                position: 'relative',
                height: '280px',
                backgroundImage: `linear-gradient(135deg, rgba(255, 107, 0, 0.9) 0%, rgba(255, 107, 0, 0.7) 100%), url("${service.image}")`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                padding: '2rem',
                color: 'white'
              }}>
                {/* Icon */}
                <div style={{
                  alignSelf: 'flex-end',
                  width: '80px',
                  height: '80px',
                  borderRadius: '20px',
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                  backdropFilter: 'blur(10px)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid rgba(255, 255, 255, 0.3)'
                }}>
                  <div style={{ transform: 'scale(0.9)', color: 'white' }}>
                    {service.icon}
                  </div>
                </div>
                
                {/* Service Title */}
                <div>
                  <h3 style={{
                    fontSize: '1.75rem',
                    fontWeight: '700',
                    margin: 0,
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    {service.title}
                  </h3>
                  <div style={{
                    width: '60px',
                    height: '4px',
                    backgroundColor: 'white',
                    borderRadius: '2px',
                    marginTop: '1rem'
                  }}></div>
                </div>
              </div>
              
              {/* Service Content */}
              <div style={{ padding: '2.5rem' }}>
                {/* Description */}
                <p style={{
                  fontSize: '1.125rem',
                  lineHeight: '1.7',
                  color: 'var(--assco-gray-700)',
                  marginBottom: '2rem'
                }}>
                  {service.description}
                </p>
                
                {/* Features */}
                <div style={{
                  marginBottom: '2rem',
                  backgroundColor: 'rgba(255, 107, 0, 0.03)',
                  borderRadius: '16px',
                  padding: '1.5rem',
                  border: '1px solid rgba(255, 107, 0, 0.1)'
                }}>
                  <h4 style={{
                    fontSize: '1.25rem',
                    fontWeight: '600',
                    color: 'var(--assco-gray-800)',
                    marginBottom: '1rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}>
                    <div style={{
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      backgroundColor: 'var(--assco-orange)'
                    }}></div>
                    {language === 'fr' ? 'Caractéristiques principales' : 
                     language === 'ar' ? 'الخصائص الرئيسية' : 
                     'Key Features'}
                  </h4>
                  
                  <ul style={{
                    listStyleType: 'none',
                    padding: 0,
                    margin: 0,
                    display: 'grid',
                    gap: '0.75rem'
                  }}>
                    {service.features.map((feature, idx) => (
                      <li 
                        key={idx}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.75rem',
                          fontSize: '1rem',
                          color: 'var(--assco-gray-700)'
                        }}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" style={{ 
                          width: '16px', 
                          height: '16px', 
                          color: 'var(--assco-orange)',
                          flexShrink: 0 
                        }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                
                {/* Benefits */}
                <div style={{
                  marginBottom: '2.5rem',
                  backgroundColor: 'rgba(56, 161, 105, 0.03)',
                  borderRadius: '16px',
                  padding: '1.5rem',
                  border: '1px solid rgba(56, 161, 105, 0.1)'
                }}>
                  <h4 style={{
                    fontSize: '1.25rem',
                    fontWeight: '600',
                    color: 'var(--assco-gray-800)',
                    marginBottom: '1rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}>
                    <div style={{
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      backgroundColor: '#38A169'
                    }}></div>
                    {language === 'fr' ? 'Avantages' : 
                     language === 'ar' ? 'الفوائد' : 
                     'Benefits'}
                  </h4>
                  
                  <ul style={{
                    listStyleType: 'none',
                    padding: 0,
                    margin: 0,
                    display: 'grid',
                    gap: '0.75rem'
                  }}>
                    {service.benefits.map((benefit, idx) => (
                      <li 
                        key={idx}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.75rem',
                          fontSize: '1rem',
                          color: 'var(--assco-gray-700)'
                        }}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" style={{ 
                          width: '16px', 
                          height: '16px', 
                          color: '#38A169',
                          flexShrink: 0 
                        }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                        </svg>
                        <span>{benefit}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                
                {/* CTA Button */}
                <div style={{ textAlign: 'center' }}>
                  <Link 
                    to="/contact" 
                    className="btn btn-primary"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '0.75rem',
                      padding: '1rem 2rem',
                      fontSize: '1.1rem',
                      fontWeight: '600',
                      borderRadius: '50px',
                      backgroundColor: 'var(--assco-orange)',
                      color: 'white',
                      textDecoration: 'none',
                      transition: 'all 0.3s ease',
                      boxShadow: '0 10px 25px -5px rgba(255, 107, 0, 0.3)',
                      border: 'none',
                      width: '100%',
                      justifyContent: 'center'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 15px 35px -5px rgba(255, 107, 0, 0.4)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 10px 25px -5px rgba(255, 107, 0, 0.3)';
                    }}
                  >
                    {language === 'fr' ? 'Demander un devis' : 
                     language === 'ar' ? 'طلب عرض أسعار' : 
                     'Request Quote'}
                    <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '18px', height: '18px' }} viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Enhanced Mobile Responsive Styles */}
      <style jsx>{`
        @media (max-width: 768px) {
          .services-grid {
            grid-template-columns: 1fr !important;
            gap: 1.5rem !important;
            margin-top: 2rem !important;
          }
          
          .service-card-enhanced {
            margin: 0 !important;
          }
          
          .stats-bar {
            flex-direction: column !important;
            gap: 1.5rem !important;
            padding: 1.5rem !important;
          }
          
          .service-header {
            height: 240px !important;
            padding: 1.5rem !important;
          }
          
          .service-content {
            padding: 2rem !important;
          }
        }
        
        @media (max-width: 480px) {
          .services-grid {
            margin-top: 1.5rem !important;
          }
          
          .service-header {
            height: 200px !important;
            padding: 1rem !important;
          }
          
          .service-content {
            padding: 1.5rem !important;
          }
          
          .stats-bar {
            gap: 1rem !important;
            padding: 1rem !important;
          }
        }
        
        .fade-in {
          opacity: 0;
          transform: translateY(30px);
          animation: fadeInUp 0.6s ease forwards;
        }
        
        /* Override section-dark styles for service cards */
        .section-dark .service-card-enhanced p,
        .section-dark .service-card-enhanced h4,
        .section-dark .service-card-enhanced span,
        .section-dark .service-card-enhanced li {
          color: var(--assco-gray-700) !important;
        }
        
        .section-dark .service-card-enhanced h4 {
          color: var(--assco-gray-800) !important;
        }
        
        @keyframes fadeInUp {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .main-services-title::after {
          display: none !important;
        }
      `}</style>
    </section>
  );
};

export default MainServicesSection;
